﻿import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from '../../core/language/language.service';
import { ToastService } from '../../core/toast/toast.service';
import { SharedService } from '../../shared/shared.service';
import { SecurityService } from '../../core/services/security.service';
import { ForgottenUsernamePasswordModel } from '../../core/models/user-basic-data/forgotten-username-password';
import { LoginService } from '../login.service';

@Component({
    selector: 'forgotten-username-password',
    templateUrl: './forgotten-username-password.component.html'
})

export class ForgottenUsernamePasswordComponent implements OnInit {
    public user: ForgottenUsernamePasswordModel;

    constructor(private _sharedService: SharedService,
        private _route: ActivatedRoute,
        private _router: Router,
        private _languageService: LanguageService,
        private _securityService: SecurityService,
        private _toastService: ToastService,
        private _loginService: LoginService) {
        this.user = new ForgottenUsernamePasswordModel();
    }

    ngOnInit() {
        this.initModel();
    }

    initModel() {
        this.user.email = null;
    }

    validateData() {
        if (this.user.email == null || this.user.email == '')
            return false;
        else
            return true;
    }

    save() {
        if (this.validateData()) {
            this._loginService.forgottenUsernamePassword(this.user).subscribe(result => {
                if (result == true) {
                    let msg = "poslat_mejl_sa_novom_lozinkom";
                    msg = this._languageService.translate(msg);
                    this._toastService.activate(msg, "alert-successToast");
                }
                else {
                    let msg = "slanje_nije_uspjelo";
                    msg = this._languageService.translate(msg);
                    this._toastService.activate(msg, "alert-danger");
                }
                this._router.navigate(['/login']);
            });
        }
    }
}